import { AwardCategory } from "@enums/awardCategory";
import emptyFieldValidate from "@validators/shared/empty.validate";
import { textLength } from "@validators/shared/textLength.validate";

export type TErrors = {
  summary: string | undefined;
  description: string | undefined;
  artist: string | undefined;
  imageUrl: string | undefined;
  year: string | undefined;
  category: string | undefined;
};

const awardValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    summary: undefined,
    description: undefined,
    artist: undefined,
    imageUrl: undefined,
    year: undefined,
    category: undefined,
  };

  if (FormValues?.category?.value === AwardCategory.WiseArtsChoice) {
    errors.summary = emptyFieldValidate(FormValues.description, "Summary");
    errors.summary = textLength(FormValues.summary, "Summary", 400);
    errors.description = emptyFieldValidate(
      FormValues.description,
      "Description"
    );
    errors.imageUrl = emptyFieldValidate(FormValues.imageUrl, "Image");
  }

  errors.artist = emptyFieldValidate(FormValues.artist, "Artist");
  errors.year = emptyFieldValidate(FormValues.year, "Year");
  errors.category = emptyFieldValidate(FormValues.category, "Category");

  return errors;
};

export default awardValidate;
